import { useSelector, useDispatch } from "react-redux";
import Constants from "../../Constants";
import ReactTooltip from "react-tooltip";
import { updateFollowersCollection } from "../../redux/reducers/ProjectFollowersSlice";
import { useEffect, useRef, useState } from "react";
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import $ from "jquery";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import DataTable from "react-data-table-component";
import { updateInitializedProjectWorkflows } from "../../redux/reducers/InitializedProjectWorkflowsSlice";
import { dateConvertToTimeStamp, timeStamp, UserNameComparator } from "../../services/Util";
import { useTranslation } from "react-i18next";
import { handleError } from "../../services/authApiRoutes/APImethods";
import { ActiveAssigneeManIcon, ActiveCannotRequestRevisionIcon, ActiveCanRequestRevisionIcon, ActiveMultiAssigneeIcon, ApprovedWorkflowStatus, calenderIcon, FollowerTooltipIcon, PlusIcon, RemoveFollowerIcon, WorkflowPhaseDateIcon } from "../../AppIcons";
import { ConditionalBlock } from "../../ConditionalBlock";
import { updateProjectInfo } from "../../redux/reducers/ProjectInfoSlice";
import dateUtil, {DATE_FORMATS} from "../../services/DateUtil";
import DateFormat from "../../pages/DateFormat";

export default function SelectWorkflow(props) {
  const { t } = useTranslation();
	const translate = t;
  const [nextAriaLabel,setNextAriaLabel] = useState('Go to next month')
  const [prevAriaLabel,setPrevAriaLabel] = useState('Go to previous month')
  const [next2AriaLabel,setNext2AriaLabel] = useState('Go to next year')
  const [prev2AriaLabel,setPrev2AriaLabel] = useState('Go to previous year')
  const [viewType,setViewType] = useState('month')
  const dispatch = useDispatch();
  const doNotShowFollowers=props.doNotShowFollowers;
  const {handleProjectFollower}=props
  const {setValidation}=props;
  const [reviewAssigneeList, setReviewAssigneeList] = useState([]);
  const [workAssigneeList, setWorkAssigneeList] = useState([]);
  const [showModalSelectWorkflow, setShowModalSelectWorkflow] = useState(false);
  const [removedProjectFollowers, setRemovedProjectFollowers] = useState([]);
  const [followersToBeAdded, setFollowersToBeAdded] = useState([]);
  const [showAssigneeList, setShowAssigneeList] = useState(false);
  const [filteredAssigneeList,  setFilteredAssigneeList] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [unassignedLanguages, setUnassignedLanguages] = useState(0);
  const [pendingLanguageSchedules, setPendingLanguageSchedules] = useState([]);
  const [assigneeListExpanded, setAssigneeListExpanded] = useState(false);
  const [dueDateCalendarExpanded, setDueDateCalendarExpanded] = useState(false);
  const [pendingLanguages, setPendingLanguages] = useState([]);
  const [disableAddFollowers, setDisableAddFollowers] = useState(true);
  const [refs, setRefs] = useState({});
	const projectFollowersTooltipRef = useRef(null);
  const [machineTranslationList, setMachineTranslationList] = useState([]);
  const [mTVendor, setMtVendor] = useState({});
  const [vendorList, setVendorsList] = useState([]);
  const [potentialAssignees,setPotentialAssignees] = useState([]); 

  let selectedProjectWorkflow = useSelector((selectedProjectWorkflowSlice) => selectedProjectWorkflowSlice.selected_project_workflow).value;
  const projectFollowers = useSelector((projectFollowersSlice) => projectFollowersSlice.project_followers);
  const projectData = useSelector((reduxStore) => reduxStore.project_info).value;
  const projectWorkflowRedux = useSelector((reduxStore) => reduxStore.initialized_project_workflows)?.value?.resource;
  const [projectWorkflows,setProjectWorkflows] = useState([]);
  const languages = useSelector((reduxStore) => reduxStore.initialized_project_workflows)?.value?.displayName;
  const [selectedMt, setSelectedMt] = useState(projectData?.translationEngineType);
  const custBootstrapDataRedux = useSelector(store => store.customer_bootstrap_data).value;
  const userTimeZone = custBootstrapDataRedux?.user?.timeZone;
  const projectEditWorkflowType=props.workflowType;
  const [refresh,setRefresh] = useState(null);
  const [mtqeThreshold,setMtqeThreshold] = useState(0);
  const isScoringEnabled = custBootstrapDataRedux?.features?.QUALITY_ESTIMATION_SCORING;
  const requestFrom =props.currentPageName;

  const viewChange = (action, activeStartDate, value, view) =>{
    setViewType(view)
    if(view === 'month'){
      setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_MONTH)
      setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_MONTH)
      setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_YEAR)
      setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_YEAR)
    }
    if(view === 'year'){
      setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_YEAR)
      setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_YEAR)
      setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_DECADE)
      setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_DECADE)
    }
    if(view === 'decade'){
        $('.react-calendar__tile--hasActive').addClass("decade-active");
        $('.react-calendar__tile--hasActive').focus()
      setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_DECADE)
      setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_DECADE)
      setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_CENTURY)
      setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_CENTURY)
    }
    if(view === 'century'){
        $('.react-calendar__tile--hasActive').addClass("decade-active");
        $('.react-calendar__tile--hasActive').focus()
      setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_CENTURY)
      setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_CENTURY)
    }
  }

const getPendingWorkflows = (id)=>{
  getAxiosResponse(APIUrls.EXISTING_PROJECT_WORKFLOW(id, "PENDING"))
  .then((respnse)=>{
    if(respnse.data.code === 200) {
      const pendingWorkflows = respnse.data.data;
      if(pendingWorkflows.length>0){
        const workflowSelection = pendingWorkflows?.filter(((wf) => wf.resource?.templateName === projectWorkflowRedux[0]?.templateName));
        if(workflowSelection?.length>0){
          let workFlows = pendingWorkflows.map(o=>o.resource);
          setProjectWorkflows(workFlows);
          setRefresh(true);
        }else{
          setProjectWorkflows(projectWorkflowRedux);
        }
      }else{
        setProjectWorkflows(projectWorkflowRedux);
      }
    }
  }).catch((err)=>{
    handleError(err);
  });
};

  useEffect(()=>{
    if(projectData?.id && projectWorkflowRedux){
      getPendingWorkflows(projectData?.id);
    }
  },[projectData]);


  const updateMTQEThreshold=()=>{
    if(projectWorkflows?.length>0){
      if(mtqeThreshold ===0 && projectWorkflows[0].templateType.originalEnum === "BUILTIN_SINGLE_STEP_THREE_PHASE"){
        setMtqeThreshold(projectWorkflows[0].mtqeThreshold)
      }
    }
  };

  const onMtqeChange = (event)=>{
    setMtqeThreshold(event?.target?.value);
    let workflows = [];
    projectWorkflows.forEach((wf)=>{
      let newWf = {...wf};
      newWf.mtqeThreshold = event?.target?.value;
      workflows.push(newWf);
    });
    setProjectWorkflows(workflows);
    setRefresh(true);
  }

  useEffect(() => {
    const fetchAssignees = async () => {
      try {
        const reviewResponse = await getAxiosResponse(APIUrls.REVIEWABLE_ASSIGNEES(projectData?.userGroup?.id));
        const workResponse = await getAxiosResponse(APIUrls.WORK_ASSIGNEES(projectData?.userGroup?.id));
        if (reviewResponse.data.code === 200) {
          const reviewAssignees = reviewResponse.data.data.map(({ customerUser, reviewLanguages }) => ({
            customerUser,
            reviewLanguages
          }));
          setReviewAssigneeList(reviewAssignees);
        }
        if (workResponse.data.code === 200) {
          const workAssignees = workResponse.data.data.map(({ customerUser }) => customerUser);
          setWorkAssigneeList(workAssignees);
        }
      } catch (error) {
        handleError(error);
      }
    };
    fetchAssignees();
  }, []);


  useEffect(()=>{
   if(reviewAssigneeList && reviewAssigneeList.length > 0){
    const groupedByReviewLanguages = reviewAssigneeList.reduce((result, item) => {
      if (item.reviewLanguages && item.reviewLanguages.length > 0) {
           item.reviewLanguages.forEach(data=>{
            result[data] = result[data] || [];
            result[data].push(item.customerUser);
          })
      }
      return result;
  }, {});
  const potentialAssignees = reviewAssigneeList.map(({customerUser})=>  customerUser.userId);
  setPotentialAssignees(potentialAssignees)
    if(projectWorkflows && projectWorkflows?.length > 0){
      var updatedWorkFlow= JSON.parse(JSON.stringify(projectWorkflows));
      updatedWorkFlow.forEach((workFlow)=>{
            if(workFlow?.language===Object.keys(groupedByReviewLanguages)?.find(key=>key===workFlow?.language)){
              if(workFlow.steps && workFlow.steps.length > 0){
                workFlow.steps.forEach((step)=>{
                   if(step?.phases && step?.phases?.length > 0){
                    step?.phases.forEach((phase)=>{
                        if(workFlow.customized === true){
                          let assignees = phase.assigneeUsers.filter(({userId})=> potentialAssignees.includes(userId));
                          Object.assign(phase, {assigneeUsers:assignees});
                        }
                        if(phase.allowMultiAssignee){
                          Object.assign(phase, {assigneeUsers:groupedByReviewLanguages[workFlow?.language]});
                        }
                    })
                   }
                })
              }
            }
      })
      let newData = {
        resource : updatedWorkFlow,
        displayName:languages
      }
     setProjectWorkflows(updatedWorkFlow)
     setRefresh(true);
    }

   }
  },[reviewAssigneeList])

  $(document).ready(function(){
    $(".rdt_Table").attr("aria-label","Add your project's followers");
    $('.rdt_Table input').parent().attr("role","cell");
  });

  const dispatchFinalDataToRedux = (type, value) => {
		dispatch(updateProjectInfo({type: type, value: value}));
	};

  useEffect(() => {
    if(refresh === true){
      let newData = {
        resource : projectWorkflows,
        displayName:languages
      }
      dispatch(updateInitializedProjectWorkflows(newData));
      if(projectWorkflows?.length>0){
        updateMTQEThreshold();
      }
      setRefresh(false);
    }
    addPresetReviewersToFollowersList();
    if(refresh === null){
      const dateTimestamp = dateConvertToTimeStamp();
      getAxiosResponse(APIUrls.MACHINE_TRANSLATION(projectData?.id) + `?_=${dateTimestamp}`)
      .then((response)=>{
        setMachineTranslationList(response?.data?.data);
      }).catch((error)=>{
        console.error(error);
      });
      getAxiosResponse(APIUrls.GET_MACHINE_TRANSLATOR)
      .then((response)=>{
        if(response?.data?.data?.length>0){
          setMtVendor(response?.data?.data[0]);
        }
      }).catch((err)=>{
        console.error(err);
      });
      getAxiosResponse(APIUrls.PREFERRED_VENDORS(projectData?.userGroup?.id))
      .then((response)=>{
        const vendors = response?.data?.data?.filter((o)=>(o.vendor.automated === false)).map((o)=>(o.vendor));
        setVendorsList(vendors);
      }).catch((err)=>{
        console.error(err);
      });
    }
  }, [projectWorkflows]);

  const addPresetReviewersToFollowersList = async () => {
    let projectOwner = projectData?.owner;
    let elementsToBeAdded = [];
    projectWorkflows?.map((workflow) => {
      workflow.steps.map((step) => {
        step.phases.map((phase) => {
          if(phase.assigneeType.code === 'customer_user' && phase.assigneeUsers.length !== 0) {
            phase.assigneeUsers.forEach((assignee)=>{
              if(assignee.enabled) {
                let elementRoleTypes = assignee.roleSet.roleTypes.map(roleType => roleType.displayName).join(", ");
                let values = [[elementRoleTypes]];
                let elementToBeAdded = {
                  id: assignee.userId,
                  label: assignee.firstName + " " + assignee.lastName,
                  resource: {
                    "path" : "",
                    "applicationVersion" : "",
                    "id" : "",
                    "customerUser" : assignee,
                    "reviewLanguages" : "",
                    "projectWorkflowAssignee" : false
                  },
                  roleSet: {
                    roleTypeList: undefined,
                    roleTypes: assignee.roleSet.roleTypes
                  },
                  value: values
                }
                elementsToBeAdded.push(elementToBeAdded);
              }
            })
          }
        })
      })
    })
    if(potentialAssignees.length>0){
      let followers = projectFollowers.followersCollection.map((follower)=>{
          let newFol = {...follower};
          if(projectOwner?.userId === newFol.id){
            newFol.unRemovable = true;
          }else{
            newFol.unRemovable = false;
          }
          return newFol;
      });
      const followerIds = followers.map(({resource})=>resource.customerUser?.userId || resource.userId);
      let updatedFollowers = elementsToBeAdded.map((element)=>{
        let presentInPotentialFollower = potentialAssignees.includes(element.id);
        if(presentInPotentialFollower){
          const isPresent = followerIds.includes(element.id);
          if(!isPresent){
            let newEle = {...element};
            newEle.unRemovable = true;
            return newEle;
          }else{
            for(let i=0;i<followers.length;i++){
              if(followers[i].id === element.id){
                let newFoll = {...followers[i]};
                newFoll.unRemovable = true;
                return newFoll;
              }
            }
          }
        }
      }).filter(Boolean);
      followers=[...followers,...updatedFollowers];
      let finalFollowers = followers.map((element)=>{
        let obj = updatedFollowers.find(({id})=>id === element.id);
        if(obj && obj.unRemovable !== element.unRemovable){
          return obj;
        }
        return element;
      });
      const uniqueFinalFollowers = Array.from(
        finalFollowers.reduce((map, obj) => map.set(obj.id, obj), new Map()).values()
      );
      dispatch(updateFollowersCollection([...uniqueFinalFollowers]));
    }else{
      dispatch(updateFollowersCollection([...projectFollowers.followersCollection, ...elementsToBeAdded]))
    }
  };

  const removeFollower = (followerId) => {
    var filteredFollowers = projectFollowers.followersCollection.filter(
      (follower) => follower.id !== followerId
    );
    var availableFollowers = projectFollowers.followersCollection.filter(
      (follower) => follower.id === followerId
    );
    setRemovedProjectFollowers((current) => [...current, availableFollowers]);
    dispatch(updateFollowersCollection(filteredFollowers));
    if($('table tr td .remove-btn').length === 1){
      setTimeout(()=>{
          $('table tr th .first-focus').trigger('focus');
      },200)
    } else if($(document.activeElement).closest('tr').is(':last-child')){
      setTimeout(()=>{
          $('table tr:last-child td .remove-btn').trigger('focus');
      },200)
    }
  };
  
  const toggleStepExpansion = (e) => {
    var step = e.target.closest(".workflow-step-list");
    if (step.classList.contains("open-step")) {
      step.classList.remove("open-step");
      $(e.target).attr('aria-expanded' , false);
    } else {
      step.classList.add("open-step");
      $(e.target).attr('aria-expanded' , true);
    }
    e.stopPropagation();
  };

  const handleSort = async (column, sortDirection) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
      .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC  ? Constants.DESCENDING : Constants.ASCENDING });
  };

  const openCalendar = (calendarState, e) => {
    if (!($(e.target).closest('.dashCalendar').has($(document.activeElement)).length > 0) && e.type==="click") {
      dueDateCalendarExpanded ? setDueDateCalendarExpanded(false) : setDueDateCalendarExpanded(true);
      showCalendar ? setShowCalendar(false) : setShowCalendar(calendarState);
      $('.popover-body-calendar').removeClass('hide');
      $('.focusAdd').trigger('focus'); 
    }
   
  };

  $(document).mouseup(function(e) {
    var bannerCont = $('.step-cal');
    if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
      setDueDateCalendarExpanded(false);
      setShowCalendar(false);
      setTimeout(() => {
        $('.step-cal.focusAdd').removeClass('focusAdd');
      }, 100);
    }
  });

  $(document).on("click keydown",".step-cal",function(e) {
    if (e.type==="click") {
      $(this).addClass('focusAdd');
    } else 
    if (e.key===Constants.ESCAPE) {
      setDueDateCalendarExpanded(false);
      setShowCalendar(false);
      $(this).trigger('focus');
      $(this).removeClass('focusAdd');
    }
  });

  const changeDate = (value, event, phaseNum, stepNum, workflowGroup, wfgIndex) => {
    const pf = { ...workflowGroup };
    const pfSteps = [...pf.steps];
    let phPhase;
    let phStep;
    let previousDate = dateUtil.convertToServerMoment(getPreviosPhaseDueDate(wfgIndex, stepNum, phaseNum));
    value.setHours(previousDate.hours());
    pfSteps.map((pfstep, stepIndex) => {
      phStep = { ...pfstep };
      if (stepIndex === stepNum - 1) {
        const pfPhases = [...pfstep.phases];
        pfPhases.map((pfphase, index) => {
          if (index === phaseNum - 1) {
            phPhase = { ...pfphase };
            phPhase.dueDate = dateUtil.convertToServerDateTsObj(value);
            pfPhases[index] = phPhase;
          }
        });
        phStep.phases = pfPhases;
      }
      pfSteps[stepIndex] = phStep;
    });
    pf.steps = pfSteps;
    let updatedProjectWfs = [...projectWorkflows];
    updatedProjectWfs[wfgIndex] = pf;
    let newData = {
      resource : updatedProjectWfs,
      displayName : languages
    }
    setProjectWorkflows(updatedProjectWfs);
    setRefresh(true);
    if (isBuiltInWorkflow()) {
      $(event.target).parents(".popover-body").siblings("span").html(dateUtil.format(value, DATE_FORMATS.MONTH_DAY, null));
    }
    setDueDateCalendarExpanded(false);
    setShowCalendar(false);
    setTimeout(() => {
      $('.step-cal.focusAdd').trigger('focus');
      $('.step-cal.focusAdd').removeClass('focusAdd');
    }, 100);
  };

  const getPreviosPhaseDueDate = (wfgindex, stepNum, phaseNum) => {
    if(stepNum !== 1 && phaseNum === 1) {
      let noOfPhases = projectWorkflows[wfgindex]?.steps[stepNum-2].phases.length;
      return projectWorkflows[wfgindex]?.steps[stepNum-2]?.phases[noOfPhases-1]?.dueDate;
    }
    return projectWorkflows[wfgindex]?.steps[stepNum-1]?.phases[phaseNum-2]?.dueDate;
  };

  const getDuration = (phaseDueDate, workflowGroup, wfgIndex, stepNum, phaseNum) => {
    if(phaseDueDate) {
      let previousPhaseDate = dateUtil.convertToServerMoment(getPreviosPhaseDueDate(wfgIndex, stepNum, phaseNum));

      let phaseDate = dateUtil.convertToServerMoment(phaseDueDate);
      let dayDiff = phaseDate.diff(previousPhaseDate, 'days');
      if (stepNum !== 1) {
        dayDiff = phaseDate.startOf('day').diff(previousPhaseDate.startOf('day'), 'days');
      }
      if(dayDiff < 0) {
        const pf = { ...workflowGroup };
        const pfSteps = [...pf.steps];
        let phPhase;
        let phStep;
        pfSteps.map((pfstep, stepIndex) => {
          phStep = { ...pfstep };
          if (phStep.stepNumber === stepNum) {
            const pfPhases = [...pfstep.phases];
            pfPhases.map((pfphase, index) => {
              if (pfphase.phaseNumber === phaseNum) {
                let currentDate = previousPhaseDate;
                if(pfphase.duration){
                  currentDate = currentDate.add(pfphase.duration, 'days')
                }
                phPhase = { ...pfphase };
                phPhase.dueDate = dateUtil.timestampObj(currentDate, true);
                pfPhases[index] = phPhase;
              }
            });
            phStep.phases = pfPhases;
          }
          pfSteps[stepIndex] = phStep;
        });
        pf.steps = pfSteps;
        let updatedProjectWfs = [...projectWorkflows];
        updatedProjectWfs[wfgIndex] = pf;
        setProjectWorkflows(updatedProjectWfs);
       setRefresh(true);
      }
    return dayDiff;
  }
  return Constants.BLANK;
  };

  const isBuiltInWorkflow = () => {
    return selectedProjectWorkflow?.workflowType?.code === "builtin_single_step" || selectedProjectWorkflow?.workflowType?.code === "builtin_single_step_autosync" || selectedProjectWorkflow?.workflowType?.code === "builtin_two_step" || selectedProjectWorkflow?.workflowType?.code === "builtin_two_step_autosync" || selectedProjectWorkflow?.workflowType?.code === "builtin_single_step_three_phase" || selectedProjectWorkflow?.workflowType?.code === "builtin_two_step_three_phase_autosync";
  };

  const setDurationInDays = (step, phase, phaseNum, stepNum, workflowGroup, wfgIndex) => {
    let previousDate = getPreviosPhaseDueDate(wfgIndex, stepNum, phaseNum);
    previousDate = dateUtil.convertToLocalDateTimestamp(previousDate);
    if (step.stepNumber !== 1 && phase.phaseNumber === 1) {
      return isBuiltInWorkflow() ? (
        <button type="button" className={phase.dueDate ? "step-cal" : "step-cal incomplete-required-field"} aria-label={phase.dueDate ? `Due Date ${dateUtil.format(phase.dueDate)}` : "Due date calendar"} aria-expanded={dueDateCalendarExpanded}  disabled={!previousDate}  onClick={ (e) => previousDate ? openCalendar(`calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`, e):false}>
          {calenderIcon}
          <span className="due-date">
            <DateFormat date={phase.dueDate} format={DATE_FORMATS.MONTH_DAY} />
          </span>
          <ConditionalBlock condition={phase?.closedDate===""}>
            <div className={showCalendar === `calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}` ? `global-dropdown-block flex-center m-0  popover-body-calendar show-assignee-dropdown p-0 calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}` : `popover-body popover-body-calendar calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`}>
              <div className="triangle-with-shadow"></div>
              <div className="inner-popover">
                <Calendar calendarType="US" locale="en" className="dashCalendar" prevAriaLabel="previous month" nextAriaLabel="next month" prev2AriaLabel="previous year" next2AriaLabel="next year" 
                minDate={previousDate ? new Date(previousDate):new Date()} 
                value={previousDate ? new Date(previousDate):new Date()}
                onChange={(value, event) => {changeDate(value, event, phaseNum, stepNum, workflowGroup, wfgIndex);}} />
              </div>
            </div>
          </ConditionalBlock>
        </button>
      ) : (
        <button type="button" className={phase.dueDate ? "step-cal" : "step-cal incomplete-required-field"} aria-label={phase.dueDate ? `Due Date ${dateUtil.format(phase.dueDate)}` : "Due date calendar"} aria-expanded={dueDateCalendarExpanded}  disabled={!previousDate}  onClick={ (e) => previousDate ? openCalendar(`calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`, e):false}>
          <span>{getDuration(phase.dueDate, workflowGroup, wfgIndex, stepNum, phaseNum)} day(s)</span>
          {WorkflowPhaseDateIcon}
          <span className="due-date">
            <DateFormat date={phase.dueDate} format={DATE_FORMATS.MONTH_DAY} />
          </span>
          <ConditionalBlock condition={phase?.closedDate===""}><div className={showCalendar === `calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}` ? `global-dropdown-block flex-center m-0  popover-body-calendar show-assignee-dropdown calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}` : `popover-body popover-body-calendar calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`}>
            <div className="triangle-with-shadow"></div>
            <div className="inner-popover">
              <Calendar calendarType="US" locale="en" 
              minDate={previousDate ? new Date(previousDate):new Date()} 
              value={previousDate ? new Date(previousDate):new Date()}
              prevAriaLabel="previous month" nextAriaLabel="next month" prev2AriaLabel="previous year" className="dashCalendar" next2AriaLabel="next year" 
              onChange={(value, event) => {changeDate(value, event, phaseNum, stepNum, workflowGroup, wfgIndex);}} />
            </div>
          </div></ConditionalBlock>
        </button>
      );
    } else if (phase.phaseNumber !== 1) {
      return isBuiltInWorkflow() ? (
        <button type="button" className={phase.dueDate ? "step-cal" : "step-cal incomplete-required-field"} aria-label={phase.dueDate ? `Due Date ${dateUtil.format(phase.dueDate)}` : "Due date calendar"} aria-expanded={dueDateCalendarExpanded} createproject-tour="first-config"  disabled={!previousDate}
        onClick={ (e) => previousDate ? openCalendar(`calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`, e): false}>
          <div className="flex-center align-center">
          {calenderIcon}
          <span className="due-date">
            <DateFormat date={phase.dueDate} format={DATE_FORMATS.MONTH_DAY} />
          </span>
          </div>
           {
            <ConditionalBlock condition={phase?.closedDate===""}>
            <div className={showCalendar === `calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}` ? `global-dropdown-block flex-center m-0  popover-body-calendar show-assignee-dropdown calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}` : `popover-body popover-body-calendar calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`}>
            <div className="triangle-with-shadow"></div>
            <div className="inner-popover">
              <Calendar calendarType="US" locale="en" prevAriaLabel="previous month" nextAriaLabel="next month" prev2AriaLabel="previous year" next2AriaLabel="next year" 
              minDate={new Date(previousDate ? new Date(previousDate):new Date())} 
              value={new Date(previousDate ? new Date(previousDate):new Date())}
              className="dashCalendar" 
              onChange={(value, event) => {changeDate(value, event, phaseNum, stepNum, workflowGroup, wfgIndex);}} />
            </div>
          </div>
          </ConditionalBlock>
      }
        </button>
      ) : (
        <button type="button" className={phase.dueDate ? "step-cal" : "step-cal incomplete-required-field"} aria-label={phase.dueDate ? `Due Date ${dateUtil.format(phase.dueDate)}` : "Due date calendar"} aria-expanded={dueDateCalendarExpanded}  disabled={!previousDate}
          onClick={ (e) => previousDate ? openCalendar(`calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`, e):false}
          onKeyDown={(e) => previousDate ?  openCalendar(`calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`, e): false}>
          <span>{getDuration(phase.dueDate, workflowGroup, wfgIndex, stepNum, phaseNum)} day(s)</span>
          {WorkflowPhaseDateIcon}
          <span className="due-date">
            <DateFormat date={phase.dueDate} format={DATE_FORMATS.MONTH_DAY} />
          </span>
          <ConditionalBlock condition={phase?.closedDate===""}><div className={showCalendar === `calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}` ? `global-dropdown-block flex-center m-0  popover-body-calendar show-assignee-dropdown calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}` : `popover-body popover-body-calendar calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`}>
            <div className="triangle-with-shadow"></div>
            <div className="inner-popover">
              <Calendar calendarType="US" locale="en" 
              minDate={new Date(previousDate ? new Date(previousDate):new Date())} 
              value={new Date(previousDate ? new Date(previousDate):new Date())}
              prevAriaLabel="previous month" nextAriaLabel="next month" prev2AriaLabel="previous year" className="dashCalendar" next2AriaLabel="next year" 
              onChange={(value, event) => {changeDate(value, event, phaseNum, stepNum, workflowGroup, wfgIndex);}} />
            </div>
          </div></ConditionalBlock>
        </button>
      );
    } else {
      return (
        <div className="step-cal inline-flex disable-focus">
          <div className='relative'>
            <span className='font-zero setFastpass'>
              <DateFormat date={phase.dueDate} format={DATE_FORMATS.MONTH_DAY} />
            </span>
            <span aria-hidden="true">
              <DateFormat date={phase.dueDate} format={DATE_FORMATS.MONTH_DAY} />
            </span>
          </div>
          <div className="popover-body popover-body-calendar">
            <div className="triangle-with-shadow"></div>
            <div className="inner-popover">
              <Calendar calendarType="US" locale="en" 
              minDate={new Date(previousDate ? new Date(previousDate):new Date())} 
              value={new Date(previousDate ? new Date(previousDate):new Date())}
              prevAriaLabel="previous month" nextAriaLabel="next month" prev2AriaLabel="previous year" className="dashCalendar" next2AriaLabel="next year" 
              onChange={(value, event) => {changeDate(value, event, phaseNum, stepNum, workflowGroup, wfgIndex);}} />
            </div>
          </div>
        </div>
      );
    }
  };

  const setPhaseType = (step, phase, numOfSteps) => {
    let phaseText = phase.name;
    if (phaseText === "") {
      phaseText = translate("other_integrations_project_creation.translation_due");
      if (numOfSteps === step.stepNumber && step.phases.length === phase.phaseNumber) {
        phaseText = translate("other_integrations_project_creation.final_review_due");
      } else if (phase.phaseType.code === "review") {
        phaseText = translate("other_integrations_project_creation.review_due");
      } else if (phase.phaseType.code === Constants.PHASE_TYPE_PE) {
        phaseText = translate("other_integrations_project_creation.post_editing_due");
      } else if (step.stepNumber !== 1 && phase.phaseType.display === Constants.PHASE_TYPE_WORK) {
        phaseText = translate("other_integrations_project_creation.work_due");
      }
    }
    return phaseText;
  };

  const setAssigneeType = (phase) => {
    const vendorTypeMapping = {
      EXTERNAL: translate("other_integrations_project_creation.phase_name_vendor"),
      EXTERNAL_BIDLESS: translate("other_integrations_project_creation.phase_name_vendor"),
      INTERNAL: translate("other_integrations_project_creation.internal_translator"),
      MACHINE_TRANSLATION: translate("select_status.machine_translation_request"),
    };
    const vendorType = projectData?.projectVendorType;
    if (vendorType) {
      if(vendorType === 'MACHINE_TRANSLATION'){
        return projectData.translationEngineType.display;
      }
      return vendorTypeMapping[vendorType];
    }
    return phase.assigneeType.display;
  };
  const selectAssignee = (e, event) => {
    if (event.type === "click" ||
      (!($(event.target).closest('.step-assignee').has($(document.activeElement)).length > 0) && event.key === Constants.ENTER) ||
      ($('.assignee-dropdown.popover-body').hasClass('p-0') && event.key === Constants.ESCAPE)) {

      setFilteredAssigneeList(null);
      assigneeListExpanded ? setAssigneeListExpanded(false) : setAssigneeListExpanded(true);

      setShowAssigneeList((prev) => {
        if (typeof (prev) === 'string' && prev === e) {
          return false;
        }
        return e;
      });
      $(event.target).closest('.step-assignee').trigger('focus');
    }

    if (event.type === "keydown" && event.key.length === 1) {
      filteredAssigneeList !== null ?
        setFilteredAssigneeList(filteredAssigneeList + event.key) : setFilteredAssigneeList(event.key);
    } else if (event.type === "keydown" && event.key === "Backspace") {

      filteredAssigneeList !== null ?
        setFilteredAssigneeList(filteredAssigneeList.slice(0, -1)) : setFilteredAssigneeList(null);
    }

    if (event.key === Constants.TAB) {
      if ($(event.target).closest('.group-radio-list div').is(':last-child') && event.key === Constants.TAB && !event.shiftKey) {
        event.preventDefault();
        $(event.target).closest('.group-radio-list').find('div:first-child input').trigger('focus');
      } else if ($(event.target).closest('.group-radio-list div').is(':first-child') && event.key === Constants.TAB && event.shiftKey) {
          event.preventDefault();
          $(event.target).closest('.group-radio-list').find('div:last-child input').trigger('focus');
      } 
    }
  };

  $(document).mouseup(function(e) {
    var bannerCont = $('.assignHidepopup');
    if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
      setAssigneeListExpanded(false);
      setShowAssigneeList(false);
    }
  });

  const checkIfUserIsAlreadyAssigned = (assigneeUsers, user) => {
    return assigneeUsers.find((assigneeUser) => assigneeUser.userId === user.userId) === undefined;
  }

  const updateAssigneeUsers = (phase, user, isChecked) => {
    const userIsAssignee = checkIfUserIsAlreadyAssigned(phase.assigneeUsers, user);
    if (phase.allowMultiAssignee) {
      const updatedAssigneeUsers = userIsAssignee && isChecked
        ? [...phase.assigneeUsers, user]
        : phase.assigneeUsers.filter(u => u.userId !== user.userId);
      
      phase.assigneeUsers = updatedAssigneeUsers;
    } else {
      phase.assigneeUsers = isChecked ? [user] : [];
    }
  };

  function validateProjectWorkflows(projectWFs){
    let isValid = true;

    projectWFs.forEach((wf) => {
      wf.steps.forEach((step) => {
        step.phases.filter((phase) => phase.phaseType.code === "review" && phase.assigneeType.code === 'customer_user').forEach((phase) => {
          // check if user is assigned for review step
          isValid = isValid && phase.assigneeUsers.length > 0;
        })
      })
    })
    return isValid;
  }

  function onValueChange(event, element, phaseNum, stepNum, workflowGroup, wfgIndex,allowMultiAssignee,assigneeType) {
    let elementExistsInFollowersList = false;
    const pf = { ...workflowGroup };
    const pfSteps = [...pf.steps];
    let phPhase;
    let phStep;
    pfSteps.map((pfstep, stepIndex) => {
      phStep = { ...pfstep };
      if (stepIndex === stepNum - 1) {
        const pfPhases = [...pfstep.phases];
        pfPhases.map((pfphase, index) => {
          if (index === phaseNum - 1) {
            phPhase = { ...pfphase };
            if(pfphase.assigneeType.originalEnum === "MACHINE_TRANSLATOR"){
              dispatchFinalDataToRedux('translationEngineType', element.code);
              setSelectedMt(element);
              phPhase.assigneeVendor = mTVendor;
              phPhase.assignedToVendor = true;
            }else if(pfphase.assigneeType.originalEnum === "CUSTOMER_USER"){
              let customerUser = {
                random: null,
                enabled: element.enabled,
                wrongPasswordAttempt: null,
                userId: element.userId,
                lastAccessedDate: null,
                locked: false,
                originalEmail: null,
                roleSet: {
                  roleTypes: element.roleSet.roleTypes,
                  roleTypeList: element.roleSet.roleTypeList,
                },
                requestedEmail: null,
                samlEnabled: element.samlEnabled,
                createdDate: null,
                language: null,
                timeZone: null,
                locale: null,
                password: null,
                email: element.email,
                customer: null,
                lastName: element.lastName,
                roleTypes: element.roleSet.roleTypes,
                userGroupMembers: null,
                activeUserGroup: null,
                title: null,
                firstName: element.firstName,
                azureSsoEnabled: element.azureSsoEnabled,
                sfdcUserId: element.sfdcUserId,
              };
              updateAssigneeUsers(phPhase, customerUser, event.target.checked);
            }else if(pfphase.assigneeType.originalEnum === "VENDOR" && pfphase.phaseType.code === Constants.PHASE_TYPE_PE){
              phPhase.assigneeVendor = element;
              phPhase.assignedToVendor = true;
            }
            pfPhases[index] = phPhase;
          }
        });
        phStep.phases = pfPhases;
      }
      pfSteps[stepIndex] = phStep;
    });
    pf.steps = pfSteps;
    let updatedProjectWfs = [...projectWorkflows];
    updatedProjectWfs[wfgIndex] = pf;

    if (setValidation) {
      setValidation(validateProjectWorkflows(updatedProjectWfs));
    }
    let newData = {
      resource : updatedProjectWfs,
      displayName : languages
    }
    setProjectWorkflows(updatedProjectWfs);
   setRefresh(true);
    if(assigneeType?.code === "customer_user"){
      projectFollowers.followersCollection.map((follower) => {
        if(follower.id === element.userId) {
          elementExistsInFollowersList = true
        }
      });
      let elementRoleTypes = element.roleSet.roleTypes.map(roleType => roleType.displayName).join(", ");
      if(!elementExistsInFollowersList) {
        let elementToBeAdded = {
          id: element.userId,
          label: element.firstName + " " + element.lastName,
          resource: {
            "path" : "",
            "applicationVersion" : "",
            "id" : "",
            "customerUser" : element,
            "reviewLanguages" : "",
            "projectWorkflowAssignee" : false
          },
          roleSet: {
            roleTypeList: undefined,
            roleTypes: element.roleSet.roleTypes
          },
          value: elementRoleTypes
        }
        dispatch(updateFollowersCollection([...projectFollowers.followersCollection, elementToBeAdded]))
        if(handleProjectFollower !== undefined) {
          handleProjectFollower([...projectFollowers.followersCollection, elementToBeAdded])
        }
      }
    }
    /**
     * Sets the assignee list to not expanded and hides the assignee list.
     * This is done after an assignee is selected.
     */
    setAssigneeListExpanded(false);
    setShowAssigneeList(false);
  }

  const checkRemoveButtonStatus = (selectedUser) => {
    const shouldHide = projectWorkflows?.some(workflow => workflow.steps.some(step =>
        step.phases.some(phase => phase.assigneeType.code === "customer_user" && phase.assigneeUsers.length > 0 &&
          (!phase.allowMultiAssignee ? phase.assigneeUsers[0].userId === selectedUser.id : phase.assigneeUsers.some(elt => elt.userId === selectedUser.id))
        )
      )
    );
    return !(shouldHide || selectedUser.unRemovable);
  };

  function displayModalSelectWorkflow() {
    setTimeout(() => {
      setShowModalSelectWorkflow(true);
      setDisableAddFollowers(true);
      document.body.classList.add("modal-open");
    }, 200);
    
    setTimeout(() => {
      $("#select-workflow-cancel-popup").trigger("focus");
      $("input[name='select-all-rows']").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
          if (e.shiftKey === true) {
            e.preventDefault();
            $("#select-workflow-cancel-popup").trigger("focus");
          }
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          hideModalSelectWorkflow();
        }
      });
      $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true"); 
      $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1");
    }, 500);
    
  }

  const handleKeyDownOnCancelSelectWorkflow = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $("input[name='select-all-rows']").trigger("focus");
      }
    }
  };

  function hideModalSelectWorkflow() {
    setShowModalSelectWorkflow(false);
    document.body.classList.remove("modal-open");
    $(".first-focus").trigger("focus");
  }

  const columns = [
    {
      name: "Name",
      selector: (row) => row.label,
      sortable: true,
    },
    {
      name: "Role",
      selector: (row) => row.value,
      sortable: true,
    },
    {
      name: "Languages",
      selector: (row) => row?.displayName[0]?.reviewLanguages.length !== 0 ? row?.displayName[0]?.reviewLanguages.map(lang => lang.display).join(", ") : "None",
      sortable: true,
    },
  ];

  const getAllFollowerData = () => {
    let data = projectFollowers.allUserGroupFollowers
                .filter(follower => !projectFollowers.followersCollection.some(addedFollower => addedFollower.id === follower.id));
    return data;
}

  const selectFollower = ({ selectedRows }) => {
    selectedRows?.length !== 0 ? setDisableAddFollowers(false) : setDisableAddFollowers(true)
    setFollowersToBeAdded(selectedRows);
  };

  const addFollower = () => {
    dispatch(updateFollowersCollection([...projectFollowers.followersCollection, ...followersToBeAdded]));
    setRemovedProjectFollowers(removedProjectFollowers.filter((y) => !followersToBeAdded.some((x) => x.id === y[0].id)));
    hideModalSelectWorkflow();
  };

  const removeLanguageSchedule = (workflowGroup, workflowGroupIndex) => {
    setPendingLanguageSchedules([...pendingLanguageSchedules, workflowGroup]);
    setUnassignedLanguages(unassignedLanguages + 1);
    let filteredSchedules = projectWorkflows.filter((projectWorkflow, index) => index !== workflowGroupIndex);
    let filteredLanguage = languages.filter((lang) => lang.name !== workflowGroup.language);
    setPendingLanguages([...pendingLanguages, languages.filter((lang) => lang.name === workflowGroup.language)[0]]);
    let updatedProjectWorkflows = {
      resource : filteredSchedules,
      displayName : filteredLanguage
    }
    setProjectWorkflows(filteredSchedules);
    dispatch(updateInitializedProjectWorkflows(updatedProjectWorkflows));
    setRefresh(false);
    setTimeout(()=>{
    const selectedElement = $(document.activeElement).closest(".wrap-workflowData");
		if($(document.activeElement).is(':last-child') && selectedElement.children().length >= 1){
      selectedElement.find('.workflowData:nth-last-child(2) .language-schedule-block .remove-btn').trigger('focus');
		 }
		 else if($(document.activeElement).is(':last-child')){
        $('.focus-btn').trigger('focus')
		 }

    },200)
  };

  const noDataFoundComponent = () => {
    return (
      <div role="rowgroup">
        <div role="row" className="no-data-display align-center">
          <div role="cell">
            <i className="nodata-icon"></i>
            <p>{Constants.NO_RECORD_FOUND}</p>
          </div>
        </div>
      </div>
    );
  };

  const addLanguageSchedule = () => {
    let workflowGroup = pendingLanguageSchedules.pop();
    setUnassignedLanguages(unassignedLanguages - 1);
    let updatedProjectWorkflow = [...projectWorkflows, workflowGroup];
    let updatedProjectWorkflows = {
      resource : updatedProjectWorkflow,
      displayName : [...languages, pendingLanguages.filter((lang) => lang.name === workflowGroup.language)[0]]
    }
    setProjectWorkflows(updatedProjectWorkflow);
    dispatch(updateInitializedProjectWorkflows(updatedProjectWorkflows));
    setRefresh(false);
  };

	$('.tooltip-container p').on('keydown', function(e){
	  if(e.key === Constants.ESCAPE){
		if ($(this).attr('id') === "projectFollowersTooltip") {
		  setRefs(projectFollowersTooltipRef);
		}
	  }
	});

	useEffect(()=>{
		if (refs.current) {
		   refs.current.hideTooltip();
		   setRefs({});
		 }
	}, [refs]);

   function RevisionStatus({ allowRevision }) {
    return (
        <div className="revision-status">
            <div className={`left-icon ${allowRevision ? 'allowed' : 'disallowed'}`}>
              {allowRevision ? ActiveCanRequestRevisionIcon : ActiveCannotRequestRevisionIcon}
            </div>
            <span className={allowRevision ? 'revision-allowed' : 'revision-disallowed'}>
                {allowRevision ? 'Can Request Revision' : 'Cannot Request Revision'}
            </span>
        </div>
    );
  } 

  const manipulateAssigneeList = (reviewAssigneeList, projectWorkflow) => {
    const languageReviewers = [];
    const otherUsers = [];
  
    reviewAssigneeList.forEach(({ customerUser, reviewLanguages }) => {
        let user = Object.assign({}, customerUser);
        if (reviewLanguages.includes(projectWorkflow.language)) {
          user.reviewLanguages = reviewLanguages.filter(lang => lang === projectWorkflow.language);
          languageReviewers.push(user);
        } else {
          user.reviewLanguages = [];
          otherUsers.push(user);
        }
    });
    return {
        languageReviewers: [...languageReviewers].sort(UserNameComparator),
        otherUsers: [...otherUsers].sort(UserNameComparator)
      };
  };

  const renderUserCheckboxes = (users, index, stepIndex, phaseIndex, onValueChange, projectWorkflow, phase, step) => (
    <div className="group-radio-list mar-bot10">
      {users?.filter((user) => {
        if (filteredAssigneeList) {
          if (user.firstName.toLowerCase().startsWith(filteredAssigneeList.toLowerCase())) {
            return true;
          }
          return false;
        }
        return true;
      }).map((element) => (
      <div className="radio-form-check" key={`${index}-${stepIndex}-${phaseIndex}-${element.userId}`}>
        <input type="checkbox" className="form-check-input"
          id={`${index}-${stepIndex}-${phaseIndex}-${element.userId}`}
            value={`${element.firstName} ${element.lastName}`}
            checked={phase?.assigneeUsers?.length > 0 ? 
              phase?.allowMultiAssignee ? 
              phase?.assigneeUsers?.some(elt => {
                if (elt.userId === element?.userId) return true;
                return false;
              }) : phase?.assigneeUsers[0]?.userId === element?.userId : false}
            onChange={(event) => onValueChange(event, element, phase.phaseNumber, step.stepNumber, projectWorkflow, index, phase.allowMultiAssignee,phase.assigneeType)}
          />
          <label className="form-check-label" htmlFor={`${index}-${stepIndex}-${phaseIndex}-${element.userId}`}>
            {`${element.firstName} ${element.lastName} (${element?.roleSet?.displayName}${
              element?.reviewLanguages?.length !== 0 && phase.phaseType.display !== Constants.PHASE_TYPE_WORK ? ` : ${element.reviewLanguages}` : ""
            })`}
          </label>
        </div>
      ))}
    </div>
  );

  const renderUserCheckboxesForMT = (index, stepIndex, phaseIndex, onValueChange, projectWorkflow, phase, step) => (
    <div className="group-radio-list mar-bot10">
      {machineTranslationList?.map((element) => (
        <div className="radio-form-check" key={`${index}-${stepIndex}-${phaseIndex}-${element.code}`}>
          <input type="checkbox" className="form-check-input"
          id={`${index}-${stepIndex}-${phaseIndex}-${element.code}`}
            value={element?.code}
            checked={selectedMt?.code === element?.code}
            onChange={(event) => onValueChange(event, element, phase.phaseNumber, step.stepNumber, projectWorkflow, index, phase.allowMultiAssignee,phase.assigneeType)}
          />
          <label className="form-check-label" htmlFor={`${index}-${stepIndex}-${phaseIndex}-${element.code}`}>
            {element?.code}
          </label>
        </div>
      ))}
    </div>
  );

  const renderUserCheckboxesForVendors = (index, stepIndex, phaseIndex, onValueChange, projectWorkflow, phase, step) => (
    <div className="group-radio-list mar-bot10">
      {vendorList?.filter((user) => {
          if (filteredAssigneeList) {
            if (user.name.toLowerCase().startsWith(filteredAssigneeList.toLowerCase())) {
              return true;
            }
            return false;
          }
          return true;
        }).map((element) => (
        <div className="radio-form-check" key={`${index}-${stepIndex}-${phaseIndex}-${element.id}`}>
          <input type="checkbox" className="form-check-input"
          id={`${index}-${stepIndex}-${phaseIndex}-${element.id}`}
          value={phase.assigneeVendor?.id === element.id ? element.name:""}
            checked={phase.assigneeVendor?.id === element.id}
            onChange={(event) => onValueChange(event, element, phase.phaseNumber, step.stepNumber, projectWorkflow, index, phase.allowMultiAssignee,phase.assigneeType)}
          />
          <label className="form-check-label" htmlFor={`${index}-${stepIndex}-${phaseIndex}-${element.id}`}>
            {element.name}
          </label>
        </div>
      ))}
    </div>
  );

  const getAssigneeList = (projectWorkflow, index, phase, step, stepIndex, phaseIndex) => {
    if(phase.assigneeType.originalEnum === "MACHINE_TRANSLATOR"){
      return renderUserCheckboxesForMT(index, stepIndex, phaseIndex, onValueChange, projectWorkflow, phase, step);
    }else{
      const { languageReviewers, otherUsers } = manipulateAssigneeList(reviewAssigneeList, projectWorkflow);
      if (phase.phaseType.display === "Review" || projectData.projectVendorType === "EXTERNAL") {
          return (
            <>
              {languageReviewers && languageReviewers?.length > 0 && <h4>Language Reviewers</h4>}
              {renderUserCheckboxes(languageReviewers, index, stepIndex, phaseIndex, onValueChange, projectWorkflow, phase, step)}
              {languageReviewers && languageReviewers?.length > 0 && <h4>Other Users</h4>}
              {renderUserCheckboxes(otherUsers, index, stepIndex, phaseIndex, onValueChange, projectWorkflow, phase, step)}
            </>
          );
      } if(phase.phaseType.code === Constants.PHASE_TYPE_PE){
        return renderUserCheckboxesForVendors(index, stepIndex, phaseIndex, onValueChange, projectWorkflow, phase, step);
      } else {
        return renderUserCheckboxes(workAssigneeList, index, stepIndex, phaseIndex, onValueChange, projectWorkflow, phase, step);
      }
    }
  };
  
  return (
    <>
      <div className="project-heading">
        <h3>{translate("other_integrations_project_creation.workflow_and_followers")}</h3>
        <span>{translate("other_integrations_project_creation.setup_dates_assigne")}{selectedProjectWorkflow.name}</span>
        {!doNotShowFollowers && <p> {translate("other_integrations_project_creation.setup_reviewers")} </p>}
      </div>
      {!doNotShowFollowers &&
        <div className="pending-schedule readonly">
          <strong>{unassignedLanguages}</strong>
          <span>{translate("other_integrations_project_creation.language_pending_schedule")}</span>
        </div>
      }
     <div className="wrap-workflowData">
      {projectWorkflows?.map((projectWorkflow, index) => {
        return (
          <div data-groupid={index} className="workflowData">
            <div className="language-schedule-block flex flex-center">
              <div className="left flex flex-center">
              {projectWorkflow?.status ==="COMPLETED" ? ApprovedWorkflowStatus :
                <span className="title">Language Schedule {index + 1}</span>}
                <div className="multiselect-output flex">
                  <div className="languageSchedule">
                    <strong>{languages?.filter((lang) => lang?.name === projectWorkflow?.language)[0]?.display}</strong>
                  </div>
                  {projectWorkflow?.status ==="COMPLETED" ? "Approved" : ""}
                </div>
                {!doNotShowFollowers && <button className="remove-btn" onClick={() => removeLanguageSchedule(projectWorkflow, index)} aria-label={'Remove Schedule ' + projectWorkflow?.language}>
                  {RemoveFollowerIcon}
                  {translate("other_integrations_project_creation.remove_schedule")}
                  </button>
                }
              </div>
            </div>
            <ConditionalBlock condition={projectWorkflow?.status !== "COMPLETED"}>
              <div className="flex workflow-content">
                <div className="workflow-main-content">
                  <div className="workflow-step-block">
                    <h6>{translate("other_integrations_project_creation.workflow_steps")}</h6>
                    <div className="workflow-wrap clearfix">
                      {projectWorkflow.steps.map((step, stepIndex) => {
                        {var numOfSteps = projectWorkflow.steps.length}
                        return (
                          <div id={"step-" + step.stepNumber} className="workflow-step-list open-step">
                            <div className="inner-step-list">
                              <button type="button"  className="step-btn" onClick={(e) => {toggleStepExpansion(e);}} aria-label={step.name + " step"} aria-expanded={true}>
                                <i className="plus-icon"></i>
                                {step.name}
                              </button>
                              <div className="workflow-step-content flex">
                                {step.phases.map((phase, phaseIndex) => {
                                  return (
                                    <div className="step-box-list" id={phase.phaseType.display + "-phase-" + phase.phaseNumber}>
                                      {setDurationInDays(step, phase, phase.phaseNumber, step.stepNumber, projectWorkflow, index)}
                                      {isBuiltInWorkflow() 
                                        && (step.stepNumber !== 1 || phase.phaseNumber !== 1) &&
                                          <div>
                                            <span>
                                              {getDuration(phase.dueDate, projectWorkflow, index, step.stepNumber, phase.phaseNumber) !== Constants.BLANK ? getDuration(phase.dueDate, projectWorkflow, index, step.stepNumber, phase.phaseNumber) + " day(s)" : ""}
                                            </span>
                                          </div>
                                      }
                                      <strong> {setPhaseType(step, phase, numOfSteps)}</strong>
                                        <ConditionalBlock condition={phase.assigneeType.code === "customer_user"}>
                                          <div className="step-assignee flex-center justify-center assignHidepopup"
                                            onClick={(e) =>selectAssignee(`assignee-list-${index + "-" + stepIndex + "-" + phaseIndex}`, e)}
                                            onKeyDown={(e) => selectAssignee(`assignee-list-${index + "-" + stepIndex + "-" + phaseIndex}`, e)}
                                            role="button" aria-label="Single Assignee" tabIndex="0"
                                            aria-expanded={assigneeListExpanded?'true':'false'} createproject-tour="assignees">
                                            <div className={phase?.closedDate !==""?"flex-center workflow-color":"flex-center"} style={{position: "relative"}}>
                                                {phase.allowMultiAssignee ?
                                                  phase.assigneeUsers.length > 0 ?
                                                    <span aria-label={`${phase.assigneeUsers.length} Reviewers selected`}
                                                      className="pl-5">{phase.assigneeUsers.length} Reviewer(s)</span>
                                                  :
                                                    <span className="incomplete-required-field">Choose Assignees</span>
                                              : <span className={!phase.assigneeUsers[0]?.firstName && "incomplete-required-field"}>
                                                {
                                                  assigneeListExpanded && showAssigneeList === `assignee-list-${index + "-" + stepIndex + "-" + phaseIndex}`
                                                    && filteredAssigneeList ?
                                                    filteredAssigneeList : phase.assigneeUsers[0]?.firstName !== undefined && phase.assigneeUsers[0]?.enabled ?
                                                      phase.assigneeUsers[0]?.firstName + " " + phase.assigneeUsers[0]?.lastName :
                                                      "Choose Assignee"
                                                }
                                              </span>
                                            }
                                            </div>
                                            {phase.allowMultiAssignee ? ActiveMultiAssigneeIcon : ActiveAssigneeManIcon}
                                            <ConditionalBlock condition={phase?.closedDate===""}>
                                                <div className={showAssigneeList === `assignee-list-${index + "-" + stepIndex + "-" + phaseIndex}` ? `assignee-dropdown popover-body show-assignee-dropdown p-0 assignee-list-${index + "-" + stepIndex + "-" + phaseIndex}` : `assignee-dropdown popover-body assignee-list-${index + "-" + stepIndex + "-" + phaseIndex}`}>
                                                  <div className="inner-popover max_height_230" role="radiogroup" aria-label="Choose Assignee">
                                                    {getAssigneeList(projectWorkflow, index, phase, step, stepIndex, phaseIndex)}
                                                  </div>
                                                </div>
                                            </ConditionalBlock>
                                          </div>
                                        </ConditionalBlock>
                                        <ConditionalBlock condition={phase.assigneeType.code === "machine_translator"}>
                                          <strong>{setAssigneeType(phase)} </strong>
                                        </ConditionalBlock>
                                        <ConditionalBlock condition={phase.assigneeType.display === "Vendor"}>
                                          <ConditionalBlock condition={phase.phaseType.code === Constants.PHASE_TYPE_PE}>
                                            {(projectEditWorkflowType === 'builtin_single_step_three_phase' || projectEditWorkflowType === 'builtin_two_step_three_phase_autosync')?
                                              <div className="step-assignee flex-center justify-center assignHidepopup">
                                                <div className="flex-center">
                                                  <span>{phase.assigneeVendor?.id !== undefined ? phase.assigneeVendor?.name : "Choose Assignee"}</span>
                                                </div>
                                                {ActiveAssigneeManIcon}
                                              </div>
                                              :
                                              <div className="step-assignee flex-center justify-center assignHidepopup"
                                                onClick={(e) => selectAssignee(`assignee-list-${index + "-" + stepIndex + "-" + phaseIndex}`, e)}
                                                onKeyDown={(e) => selectAssignee(`assignee-list-${index + "-" + stepIndex + "-" + phaseIndex}`, e)}
                                                role="button" aria-label="Single Assignee" tabIndex="0"
                                                aria-expanded={assigneeListExpanded ? 'true' : 'false'} createproject-tour="assignees">
                                                <div className="flex-center" style={{position: "relative"}}>
                                                <span className={phase.assigneeVendor?.id == undefined && "incomplete-required-field"}>
                                                  { 
                                                    assigneeListExpanded && showAssigneeList === `assignee-list-${index + "-" + stepIndex + "-" + phaseIndex}`
                                                      && filteredAssigneeList ?
                                                      filteredAssigneeList : phase.assigneeVendor?.id !== undefined ? phase.assigneeVendor?.name :
                                                        "Choose Assignee"
                                                  }
                                                </span>
                                                </div>
                                                {phase.allowMultiAssignee ? ActiveMultiAssigneeIcon : ActiveAssigneeManIcon}
                                                <div className={showAssigneeList === `assignee-list-${index + "-" + stepIndex + "-" + phaseIndex}` ? `assignee-dropdown popover-body show-assignee-dropdown p-0 assignee-list-${index + "-" + stepIndex + "-" + phaseIndex}` : `assignee-dropdown popover-body assignee-list-${index + "-" + stepIndex + "-" + phaseIndex}`}>
                                                  <div className="inner-popover max_height_230" role="radiogroup" aria-label="Choose Assignee">
                                                    {getAssigneeList(projectWorkflow, index, phase, step, stepIndex, phaseIndex)}
                                                  </div>
                                                </div>
                                              </div>
                                            }
                                          </ConditionalBlock>
                                          <ConditionalBlock condition={phase.phaseType.code !== Constants.PHASE_TYPE_PE}>
                                            <strong>{setAssigneeType(phase)} </strong>
                                          </ConditionalBlock>
                                        </ConditionalBlock>
                                      <div className="step-request">
                                        <RevisionStatus allowRevision={phase.allowRevision} />
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </ConditionalBlock>
          </div>
        );
      })}
      </div>
     {!doNotShowFollowers && <button type="button" className="dashboard-btn focus-btn" disabled={unassignedLanguages === 0} onClick={() => addLanguageSchedule()}>
        {PlusIcon}
        Add New Schedule
      </button>
      }      
    {!doNotShowFollowers &&
      <div className="project-follower-block">
        <div className="tooltip-container">
          <h6>Project followers </h6>
          <p tabindex={0} data-events={['focus']} data-eventsoff={['blur']} data-padding="10px 10px 10px 10px" id='projectFollowersTooltip' aria-label='tooltip' data-place="right" data-tip={Constants.PROJECT_FOLLOWERS_TOOLTIP} data-for="projectFollowers">
            {FollowerTooltipIcon}
            <div className="font-zero">{Constants.PROJECT_FOLLOWERS_TOOLTIP}</div>
          </p>
          <ReactTooltip className="tooltip" id="projectFollowers" role='tooltip' ref={projectFollowersTooltipRef} />
        </div>
        <p>{translate("other_integrations_project_creation.receive_notifications")}</p>
        <div className="table-responsive">
          <table className="table" aria-label="Project followers">
            <tr>
              <th aria-label="Name">Name</th>
              <th aria-label="Role">Role</th>
              <th>
                <button type="button" aria-label="Add Follower" className="first-focus" onClick={displayModalSelectWorkflow}>Add Follower</button>
              </th>
            </tr>
            {Object.entries(projectFollowers.followersCollection).map(
              ([label, value]) => {
                return (
                  <tr>
                    <td>{value.label} {projectData?.owner?.userId === value.id ? "(Owner)" : ""}</td>
                    <td>{value.value}</td>
                    <td>
                        <ConditionalBlock condition={(projectData?.owner?.userId !== value.id && checkRemoveButtonStatus(value))}>
                          <button type="button" className="remove-btn" onClick={() => {removeFollower(value.id);}}>
                            {RemoveFollowerIcon}
                            Remove
                          </button>
                        </ConditionalBlock>
                    </td>
                  </tr>
                );
              }
            )}
          </table>
        </div>
      </div>
}
      {showModalSelectWorkflow && (
        <div id="modelPopup" className="lightbox-panel" aria-labelledby="followers" aria-modal="true" role="dialog">
          <div className="inner-lightbox-panel popup-inner">
            <div className="modal-header flex popup-header">
              <strong id="followers">{translate("other_integrations_project_creation.add_project_followers")}</strong>
            </div>
            <div className="lightbox-content popup-content">
              <div className="table-responsive datatable-block">
                <DataTable
                  columns={columns}
                  data={getAllFollowerData()}
                  onSort={handleSort}
                  selectableRows
                  onSelectedRowsChange={selectFollower}
                  noDataComponent={noDataFoundComponent()}
                  />
              </div>
            </div>
            <div className="modal-footer popup-footer flex justify-end">
              <button type="button" id="select-workflow-add-follower" className="btn btn-bold active" onClick={addFollower} disabled={disableAddFollowers}>
                {translate("other_integrations_project_creation.add")}
              </button>
              <button type="button" id="select-workflow-cancel-popup" className="btn btn-bold" onClick={hideModalSelectWorkflow} onKeyDown={(e) => {handleKeyDownOnCancelSelectWorkflow(e)}}>
                {translate("other_integrations_project_creation.cancel")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
